import { render, staticRenderFns } from "./ContactColumn2.vue?vue&type=template&id=107ac45a&scoped=true&"
import script from "./ContactColumn2.vue?vue&type=script&lang=js&"
export * from "./ContactColumn2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ac45a",
  null
  
)

export default component.exports